import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-background-100 pt-16 pb-8">
      <div className="mx-4 lg:mx-8 rounded-2xl bg-background-50 p-8 lg:p-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-bank-card-line text-background-50 text-sm" />
              </div>
              <span className="text-foreground-950 font-bold text-lg">
                BankCheckData
              </span>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed mb-4">
              株式会社銀行データカードは、金融データ処理とカード決済ソリューションのリーディングプロバイダーです。
              安全で効率的なデータ管理を、日本の金融機関に提供しています。
            </p>
            <p className="text-foreground-500 text-xs">
              メール: admin@bankcheckdata-card.jp
            </p>
          </div>

          {/* Links Columns */}
          <div>
            <h4 className="text-primary-500 text-xs font-bold uppercase tracking-wider mb-4">
              ナビゲーション
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/");
                  }}
                  className="text-foreground-600 text-sm hover:text-primary-500 transition-colors"
                >
                  ホーム
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/services");
                  }}
                  className="text-foreground-600 text-sm hover:text-primary-500 transition-colors"
                >
                  サービス
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/contact");
                  }}
                  className="text-foreground-600 text-sm hover:text-primary-500 transition-colors"
                >
                  お問い合わせ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-primary-500 text-xs font-bold uppercase tracking-wider mb-4">
              法務
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/privacy"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/privacy");
                  }}
                  className="text-foreground-600 text-sm hover:text-primary-500 transition-colors"
                >
                  プライバシーポリシー
                </a>
              </li>
              <li>
                <a
                  href="/terms"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/terms");
                  }}
                  className="text-foreground-600 text-sm hover:text-primary-500 transition-colors"
                >
                  利用規約
                </a>
              </li>
              <li>
                <a
                  href="/cookies"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/cookies");
                  }}
                  className="text-foreground-600 text-sm hover:text-primary-500 transition-colors"
                >
                  Cookie ポリシー
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2026 BankCheckData-Card.jp. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center hover:bg-primary-600 transition-colors"
              aria-label="Twitter"
            >
              <i className="ri-twitter-x-fill text-background-50 text-xs" />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center hover:bg-primary-600 transition-colors"
              aria-label="LinkedIn"
            >
              <i className="ri-linkedin-fill text-background-50 text-xs" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}